import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { AuthenticationService } from '../services';

@Injectable()
export class AuthenticationGuard  {
    constructor(private authenticationService: AuthenticationService, private router: Router) { }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        if (this.authenticationService.getToken() === '') {
            this.router.navigate(['/auth'], { replaceUrl: true });
        }

        return true;
    }
}
